export function NoAccess() {
  return (
    <div className="app">
      <h1>No access</h1>
      <p style={{ color: 'var(--text-dim)' }}>
        You don't have access to alerts yet. Contact the admin to get added.
      </p>
    </div>
  )
}
